import React from 'react';
import classnames from 'classnames';
import s from './AvatarPlaceholder.scss';
const AvatarPlaceholder = ({ className, isGroup, width, height, 'aria-hidden': ariaHidden, alt })=>{
    const icon = isGroup ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 12"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.65 2.65a2.65 2.65 0 11-5.3 0 2.65 2.65 0 015.3 0zM3.14 1c.133 0 .263.011.39.032a3.728 3.728 0 00-.483 1.84c0 1.012.401 1.93 1.053 2.604A2.34 2.34 0 113.14 1zM2.625 7l.915.009a.263.263 0 01.238.368l-1.521 3.468a.262.262 0 01-.24.157h-.95a.466.466 0 01-.33-.13 14.04 14.04 0 01-.568-.605c-.115-.131-.123-.285-.036-.436L1.608 7.26a.5.5 0 01.427-.252L2.625 7zM5.37 7.312c.08-.183.259-.3.458-.3h2.346a.5.5 0 01.458.3l1.512 3.435a.5.5 0 01-.032.464l-.34.552a.5.5 0 01-.426.237H4.654a.5.5 0 01-.425-.237l-.335-.542a.513.513 0 01-.03-.482c.34-.749 1.182-2.681 1.506-3.427zM11.375 7l-.915.009a.263.263 0 00-.238.368l1.522 3.468a.262.262 0 00.24.157h.95a.466.466 0 00.33-.13c.181-.18.412-.43.567-.605.115-.131.123-.285.037-.436L12.392 7.26a.5.5 0 00-.427-.252L11.375 7zM10.86 1c-.133 0-.263.011-.39.032.308.544.483 1.172.483 1.84 0 1.012-.401 1.93-1.053 2.604A2.34 2.34 0 1010.86 1z"
    })) : /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: s['icon']
    }, /*#__PURE__*/ React.createElement("title", null, alt), /*#__PURE__*/ React.createElement("path", {
        d: "M50 49.82c6.732 0 12.188-5.416 12.188-12.097 0-6.682-5.456-12.098-12.188-12.098-6.73 0-12.188 5.416-12.188 12.098 0 6.681 5.457 12.098 12.189 12.098zM44.047 53.89c-.663 0-1.269.36-1.568.935-1.452 2.79-5.746 11.047-7.299 14.086a1.647 1.647 0 00.082 1.64l1.91 3.011c.32.505.887.813 1.497.813h22.67a1.77 1.77 0 001.498-.813l1.9-2.997a1.671 1.671 0 00.075-1.669L57.53 54.831a1.765 1.765 0 00-1.571-.942H44.047z"
    }));
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isGroup && s['is-group'], className),
        style: {
            width,
            height
        },
        "aria-hidden": ariaHidden
    }, icon);
};
AvatarPlaceholder.displayName = 'AvatarPlaceholder';
export default AvatarPlaceholder;

//# sourceMappingURL=AvatarPlaceholder.js.map